import {Box} from "@mui/system";
import React from "react";
import styles from "./styles/Styles.module.css"

/**
 * @param label {string}
 * @param link {string}
 * @param buttonBordered {boolean}
 * @param sx
 * @returns {JSX.Element}
 * @constructor
 */
export default function AnchorButton({ label, link, buttonBordered }) {
    return(
        <Box sx={styles}>
            <a href={link} className={buttonBordered ? styles.buttonBordered : styles.buttonColored}>
                {label}
            </a>
        </Box>
    )
}